/* eslint-disable @typescript-eslint/no-explicit-any */
// Inlined from web/src/tiptap/lib/helpers/{resolveExtensions,flattenExtensions,sortExtensions}
// + web/src/tiptap/lib/utilities/findDuplicates. The original web copies were
// imports from a forked tiptap-core internal layout with broken type-only
// imports to non-existent ../Extension.js / ../types.js paths. We compose
// against `@tiptap/core`'s public surface instead so this stays self-contained.
import { type Extensions, getExtensionField } from '@tiptap/core';

function findDuplicates<T>(items: T[]): T[] {
  const filtered = items.filter((el, index) => items.indexOf(el) !== index);
  return Array.from(new Set(filtered));
}

function flattenExtensions(extensions: Extensions): Extensions {
  return (
    extensions
      .map((extension) => {
        const context = {
          name: extension.name,
          options: extension.options,
          storage: extension.storage,
        };
        const addExtensions = getExtensionField<any>(extension, 'addExtensions', context);
        if (addExtensions) {
          return [extension, ...flattenExtensions(addExtensions())];
        }
        return extension;
      })
      .flat(10)
  );
}

function sortExtensions(extensions: Extensions): Extensions {
  const defaultPriority = 100;
  return extensions.sort((a, b) => {
    const priorityA = getExtensionField<number>(a, 'priority') || defaultPriority;
    const priorityB = getExtensionField<number>(b, 'priority') || defaultPriority;
    if (priorityA > priorityB) return -1;
    if (priorityA < priorityB) return 1;
    return 0;
  });
}

export function resolveExtensions(extensions: Extensions): Extensions {
  const resolvedExtensions = sortExtensions(flattenExtensions(extensions));
  const duplicatedNames = findDuplicates(resolvedExtensions.map((extension) => extension.name));

  if (duplicatedNames.length) {
    // eslint-disable-next-line no-console
    console.warn(
      `[tiptap warn]: Duplicate extension names found: [${duplicatedNames
        .map((item) => `'${item}'`)
        .join(', ')}]. This can lead to issues.`,
    );
  }

  return resolvedExtensions;
}
